<template>
  <div class="page-section">
    <div :class="containerClass">
      <h2 class="text-center mb-3">Checklist</h2>
      <p class="text-center checklist-description mb-4">Track and complete your onboarding tasks.</p>

      <div class="card">
        <div class="card-body">
          <div v-for="(guide, index) in organizationDashboard" :key="guide.id">
            <guide-row
              :title="guide.title"
              :description="guide.description"
              :isLoading="false"
              :redirect-to="guide.redirectTo"
              :status="orgStatuses"
              :icon="guide.icon"
              :abbr="guide.abbr"
              :btn-text="guide.btnText"
            />
            <hr v-if="index + 1 < organizationDashboard.length" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Page from '../../../components/Page.vue';
import GuideRow from './GuideRow.vue';
import { DASHBOARD_TYPES } from '@/common/constants';

export default {
  extends: Page,
  name: 'OrgChecklist',
  components: { GuideRow },
  data() {
    return {
      title: 'Checklist',
      orgStatuses: {},
      organizationDashboard: [
        {
          id: 2,
          title: 'Take a Career Assessment',
          abbr: 'career_assessment',
          btnText: 'Complete',
          description: 'Complete a Basic Assessment to earn 1 point or an Advanced Assessment to earn 5.',
          enable: true,
          icon: 'assessment',
          redirectTo: '',
        },
        {
          title: 'Add Education to Resume',
          abbr: 'education_resume',
          btnText: 'Complete',
          description: 'Earn 1 point for every education entry added to your resume.',
          enable: true,
          icon: 'description',
          redirectTo: 'std-manage-resume',
        },
        {
          title: 'Add Work Experience to Resume',
          abbr: 'work_experience_resume',
          btnText: 'Complete',
          description: 'Earn 1 point for each work experience entry you include in your resume.',
          enable: true,
          icon: 'description',
          redirectTo: 'std-manage-resume',
        },
        {
          title: 'Add Volunteer Work Experience to Resume',
          abbr: 'volunteer_experience_resume',
          btnText: 'Complete',
          description: 'Earn 1 point for each volunteer work experience entry you include in your resume.',
          enable: true,
          icon: 'description',
          redirectTo: 'std-manage-resume',
        },
        {
          title: 'Add Skills to Resume',
          abbr: 'skills_resume',
          btnText: 'Complete',
          description: 'Earn 1 point for each skill entry to your resume.',
          enable: true,
          icon: 'description',
          redirectTo: 'std-manage-resume',
        },
        {
          title: 'Add Latest Title and Location to Resume',
          abbr: 'latest_title_location_resume',
          btnText: 'Complete',
          description: 'Earn up to 2 points for adding your current job title and location.',
          enable: true,
          icon: 'description',
          redirectTo: 'std-manage-resume',
        },
        {
          title: 'Practice Interview Simulations',
          abbr: 'practice_skill_simulations',
          btnText: 'Complete',
          description: 'Earn 3 points for completing an interview.',
          enable: true,
          icon: 'mic',
          redirectTo: 'student-simulations-listing',
        },
        {
          title: 'Add Certifications',
          abbr: 'add_certifications',
          btnText: 'Complete',
          description: 'Earn 5 points for each certification you upload to your profile.',
          enable: true,
          icon: 'assignment_turned_in',
          redirectTo: 'my-certifications',
        },
        {
          title: 'Add New Job Offers',
          abbr: 'add_new_offers',
          btnText: 'Complete',
          description: 'Earn 3 points for every offers entry you include to demonstrate career progress.',
          enable: true,
          icon: 'work',
          redirectTo: 'my-offers',
        },
        {
          title: 'Add New Research',
          abbr: 'add_new_research',
          btnText: 'Complete',
          description: 'Earn 5 points for every research entry you include to demonstrate your expertise.',
          enable: true,
          icon: 'menu_book',
          redirectTo: 'my-research',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getLoggedInUserDashboard']),
  },
  methods: {
    ...mapActions('student', ['getDashboardScore']),
    async fetchDashboardScore() {
      try {
        this.orgStatuses = (
          await this.getDashboardScore({
            ...(this.getLoggedInUserDashboard !== DASHBOARD_TYPES.CARECAMPUS && {
              id: this.getLoggedInUser.linked_entity.id,
              entity_type: 'organization',
            }),
          })
        ).data;
      } catch (_err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
  },
  async mounted() {
    if (this.getLoggedInUser && this.getLoggedInUser.linked_entity) {
      this.fetchDashboardScore();
    }
  },
};
</script>

<style scoped>
.checklist-description {
  color: #525f7f;
}
</style>
